<template>
  <span class="scaling-svg-container">
    <svg
      data-name="Icon/013-invoice"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="13.998"
      viewBox="0 0 16 13.998"
      class="scaling-svg"
    >
      <path
        data-name="Combined Shape"
        d="M3.661,14A.657.657,0,0,1,3,13.341V6.655H.657A.657.657,0,0,1,0,6V.657A.657.657,0,0,1,.657,0H15.343A.657.657,0,0,1,16,.657V6a.657.657,0,0,1-.657.657H13v6.686a.657.657,0,0,1-.657.657Zm.657-1.315h7.364v-8.7H4.318ZM12.339,2.67A.657.657,0,0,1,13,3.327V5.341h1.69V1.314H1.314V5.341H3V3.327a.657.657,0,0,1,.657-.657ZM6,10.994A.657.657,0,1,1,6,9.68H9a.657.657,0,1,1,0,1.314ZM6,8.657A.657.657,0,0,1,6,7.343H10a.657.657,0,0,1,0,1.314ZM6,6.321A.657.657,0,0,1,6,5.007H8.334a.657.657,0,0,1,0,1.314Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PrintIcon extends Vue {}
</script>

<style>
</style>
